import { AxiosResponse } from 'axios';
import { toast } from 'react-toastify';

import { viaCepSearch } from '@/routes/addresses';
import { IViacepAddress } from '@/store/ducks/viacep/type';

export const useViaCepSearch = async (zipcode: string) => {
  try {
    const response: AxiosResponse<IViacepAddress> = await viaCepSearch(zipcode.split('-').join(''));
    const address: IViacepAddress = response as unknown as IViacepAddress;
    return address
      ? {
          street: address.logradouro,
          city: address.localidade,
          state: address.uf,
          neighborhood: address.bairro,
          zipcode: address.cep,
        }
      : null;
  } catch (error) {
    toast.error('Erro ao buscar endereço via CEP');
    return null;
  }
};
